








































































import { Component, Vue, Inject } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import EditRole from './role/EditRole.vue';
import { Page } from '@/data/models/page.model';
import { Role, RoleFeature } from '@/data/models/role.model';
import { Feature } from '@/data/models/feature.model';
import { Search } from '@/data//models/search.model';

@Component({
	components: {},
})
export default class RoleFeatures extends Vue {
	@Inject('CrudService') roleCrudService!: CrudService<Role>;
	@Inject('CrudService') featureCrudService!: CrudService<Feature>;
	@Inject('CrudService') rolefeaturesCrudService!: CrudService<RoleFeature>;

	roles: Role[] = [];
	features: Feature[] = [];
	rolefeatures: RoleFeature[] = [];
	selectedRole: Role | null = null;

	constructor() {
		super();
		this.roles = [];
		this.features = [];
	}

	loadRoles() {
		this.roleCrudService
			.getAll(Role, 'role')
			.then((results) => {
				this.roles = results;
				this.selectedRole = this.roles[0];
				this.loadRoleFeatures();
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	loadFeatures() {
		this.featureCrudService
			.getAll(Feature, 'systemfeature')
			.then((results) => {
				this.features = results;
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	loadRoleFeatures() {
		const search = new Search('roletofeature');
		search.addSimpleFilter('rid', this.selectedRole!.id);
		this.rolefeaturesCrudService
			.searchEntities(RoleFeature, 'roletofeature', search, new Page(100))
			.then((results) => {
				this.rolefeatures = results;
			});
	}

	addRuolo() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditRole,
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Role) => {
					this.roleCrudService
						.createEntity(Role, 'role', value)
						.then(() => {
							this.$buefy.notification.open({
								message: this.$t('success-save') as string,
								type: 'is-success',
							});
							this.loadRoles();
							modal.close();
						})
						.catch(({ data }) => {
							this.$buefy.notification.open({
								message: data.msg || data.internal,
								type: 'is-danger',
							});
						});
				},
			},
		});
	}

	addRemoveFeature(featureid: number) {
		if (this.isFeatureChecked(featureid)) {
			const index = this.rolefeatures
				.map((feat) => feat.fid)
				.indexOf(featureid);
			const rolefeature = this.rolefeatures[index];
			this.rolefeaturesCrudService
				.deleteEntity(RoleFeature, 'roletofeature', rolefeature)
				.then(() => {
					this.rolefeatures.splice(index, 1);
				});
		} else {
			const rolefeature = new RoleFeature();
			rolefeature.rid = this.selectedRole!.id;
			rolefeature.fid = featureid;
			this.rolefeaturesCrudService
				.createEntity(RoleFeature, 'roletofeature', rolefeature)
				.then((result) => {
					this.rolefeatures.push(result);
				});
		}
	}

	isFeatureChecked(featureid: number) {
		return this.rolefeatures && this.rolefeatures.map((feat) => feat.fid).indexOf(featureid) >= 0;
	}

	setSelectedRole(role: Role) {
		if (!this.selectedRole || role.id !== this.selectedRole.id) {
			this.selectedRole = role;
			this.loadRoleFeatures();
		}
	}

	beforeMount() {
		this.loadRoles();
		this.loadFeatures();
	}

	deleteRuolo(item: Role) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-ruolo-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			onConfirm: () => {
				this.roleCrudService
					.deleteEntity(Role, 'role', item)
					.then(() => {
						this.loadRoles();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}
}
